export default __webpack_public_path__ + "static/media/prev.3efb7a3c.svg";